import "./LastSmokedRoot.scss";

import { useRouteMatch, Switch, Route } from "react-router";

import { LastSmoked } from "./LastSmoked";
import { IneligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";
import { Pages } from "../../../../data/eligibilityChecker/smokeFree/pages";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { IsObjectEmptyOrNull } from "../../../../utils/IsEmpty";

interface Props {
  progressPercentage?: PowerOfTen;
}

const LastSmokedIneligibleScreen = () => {
  const ineligibleScreen = Pages.lastSmoked.ineligibleScreen;

  return (
    <IneligibleScreen
      title={ineligibleScreen.title}
      heading={ineligibleScreen.heading}
      bodyText={ineligibleScreen.body}
      hasContactUs={true}
    />
  );
};

export const LastSmokedRoot = ({ progressPercentage }: Props) => {
  let { path } = useRouteMatch();

  const dispatch = useDispatch();
  useEffect(() => {
    if (!IsObjectEmptyOrNull(progressPercentage)) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <div className="last-smoked-root">
      <Switch>
        <Route exact path={`${path}`} component={LastSmoked} />
        <Route path={`${path}/fail`} component={LastSmokedIneligibleScreen} />
      </Switch>
    </div>
  );
};
